import React from "react"
import { Routes, Route, Navigate, useLocation } from "react-router-dom"
import { isNull } from "lodash"
import { useAuth } from "@/features/auth/context/AuthContext"

import Loader from "@/shared/components/loader"
import LandingPage from "@/features/landing"
import UserDetails from "@/features/auth/components/UserDetails"
import VerifyEmail from "@/features/auth/components/VerifyEmail"
import EmailVerification from "@/features/auth/components/EmailVerification"
import ForgotPassword from "@/features/auth/components/ForgotPassword"
import ResetPassword from "@/features/auth/components/ResetPassword"
import GlobalSnackbar from "@/shared/components/snackbar"
import GeneratingImagesIndicator from "@/shared/components/generating-images-indicator"
import AuthenticatedAppBar from "@/shared/components/appbar/AuthenticatedAppBar"
import UnauthenticatedAppBar from "@/shared/components/appbar/UnauthenticatedAppBar"
import BillingSuccess from "@/features/billing/components/BillingSuccess"
import Home from "@/features/auth"
import PrivacyPolicyPage from "@/features/legal/components/PrivacyPolicyPage"
import TermsOfUsePage from "@/features/legal/components/TermsOfUsePage"

const App = () => {
  const { user, userDetails, loading, setUserDetails } = useAuth()
  const location = useLocation()

  if (loading) return <Loader />
  const showUnauthAppBar = isNull(user) && location.pathname !== "/"

  return (
    <>
      {showUnauthAppBar && <UnauthenticatedAppBar />}
      {!isNull(user) && user.emailVerified && <AuthenticatedAppBar />}
      <Routes>
        <Route path="/__/auth/action" element={<EmailVerification />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfUsePage />} />
        {!isNull(user) && !user.emailVerified && (
          <>
            <Route path="/" element={<VerifyEmail />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
        {!isNull(user) && isNull(userDetails) && (
          <Route path="*" element={<UserDetails onUpdated={setUserDetails} />} />
        )}
        {!isNull(user) && user.emailVerified && !isNull(userDetails) && (
          <>
            <Route path="/billing/success" element={<BillingSuccess />} />
            <Route path="/*" element={<Home />} />
          </>
        )}
        {isNull(user) && (
          <>
            <Route path="/" element={<LandingPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
      <GlobalSnackbar />
      <GeneratingImagesIndicator />
    </>
  )
}

export default App
